module.exports = __webpack_public_path__ + "img/flower-02.f459b672.png";